const SvgHamburger = () => (
	<svg width="1em" height="1em" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M2 2h20M2 9.143h20M2 16.286h20" stroke="#100D3D" strokeWidth={3} strokeLinecap="round" />
	</svg>
)

export default SvgHamburger
